export default {
  id: 'slack_schedule_jobs',
  title: 'Schedule jobs',
  type: 'Direct',
  relations: [ 'MANY_JOBS' ],
  description: 'Send a call to action button of up to 4 selected jobs to your employees so they can easily schedule to share them actross their network.',
  body: {
    blocks: [
      {
        text: {
          text: '[[INPUT_SHARE_SCHEDULE_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      },
      {
        type: 'actions',
        elements: [
          {
            url: '{{JOB_LINKEDIN_SCHEDULE_LINK}}',
            text: {
              text: 'Schedule LinkedIn Posts',
              type: 'plain_text',
              emoji: true
            },
            type: 'button'
          }
        ]
      },
      {
        text: {
          text: '[[INPUT_END_TEXT]]',
          type: 'mrkdwn'
        },
        type: 'section'
      }
    ]
  },
  inputs: {
    INPUT_SHARE_SCHEDULE_TEXT: {
      label: 'Schedule',
      placeholder: 'Schedule your job shares to go out at the best times for your network ...',
      defaultValue: 'Schedule your job shares to go out at the best times for your network and win some awesome rewards.',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text at the end',
      placeholder: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}...',
      defaultValue: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/slack/scheduleJobs.js